import { ModalConfig } from '../../../contexts/modalContext';

import TemplateModal from './TemplateModal';
import TemplateAPIResponseModal from './TemplateAPIResponseModal';

export const modalConfig: ModalConfig = {
    templateModal: {
        id: 'templateModal',
        modalComponent: TemplateModal,
    },
    templateApiResponseModal: {
        id: 'templateApiResponseModal',
        modalComponent: TemplateAPIResponseModal,
    },
};
